import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, Badge } from "../../components/ui-extras";
import { formatCard } from "../../lib/cardDisplay";
import { LockKey, PencilSimple } from "@phosphor-icons/react";
import CardChangeRequestModal from "../../components/CardChangeRequestModal";

export default function CustomerCards() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingCard, setEditingCard] = useState(null);

  const reload = () => {
    setLoading(true);
    api.get("/cards")
      .then(({ data }) => setRows(data || []))
      .finally(() => setLoading(false));
  };

  useEffect(reload, []);

  return (
    <>
      <PageHeader
        title="Fuel cards"
        subtitle="PORTAL / CARDS"
        testId="portal-cards-header"
      />

      <div
        className="gf-card mb-4 border-l-4 border-zinc-300 bg-zinc-50/40"
        data-testid="portal-cards-readonly-notice"
      >
        <div className="gf-card-body flex items-center gap-3 text-sm text-zinc-600">
          <LockKey size={16} className="text-zinc-400" />
          Cards are read-only here. Use <strong>Request Change</strong> to
          submit an update to Driver Name, Unit #, Phone # or PIN # — your
          account manager will review within 24 hours.
        </div>
      </div>

      <div className="gf-card">
        <table className="gf-table" data-testid="portal-cards-table">
          <thead>
            <tr>
              <th>NETWORK</th>
              <th>CARD #</th>
              <th>DRIVER NAME</th>
              <th>PHONE #</th>
              <th>UNIT #</th>
              <th>STATUS</th>
              <th className="text-right">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.card_id} data-testid={`portal-card-row-${c.card_id}`}>
                <td className="overline text-[11px]">{(c.network || "").toUpperCase()}</td>
                <td className="font-mono" data-testid={`portal-card-number-${c.card_id}`}>
                  {formatCard(c.card_number, c.network, c.last4)}
                </td>
                <td className="text-sm" data-testid={`portal-card-driver-${c.card_id}`}>
                  {c.driver_id || c.driver_name || "—"}
                </td>
                <td className="font-mono text-sm" data-testid={`portal-card-phone-${c.card_id}`}>
                  {c.phone || "—"}
                </td>
                <td className="font-mono text-sm" data-testid={`portal-card-unit-${c.card_id}`}>
                  {c.unit || "—"}
                </td>
                <td>
                  <Badge
                    variant={c.status === "active" ? "success" : "muted"}
                    data-testid={`portal-card-status-${c.card_id}`}
                  >
                    {c.status || "—"}
                  </Badge>
                </td>
                <td className="text-right">
                  <button
                    onClick={() => setEditingCard(c)}
                    className="gf-btn gf-btn-outline text-xs"
                    data-testid={`portal-card-request-change-${c.card_id}`}
                  >
                    <PencilSimple size={12} /> Request change
                  </button>
                </td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td
                  colSpan={7}
                  className="text-center text-zinc-400 py-10"
                  data-testid="portal-cards-empty"
                >
                  No cards on file. Contact your account manager to request a
                  new card.
                </td>
              </tr>
            )}
            {loading && (
              <tr>
                <td colSpan={7} className="text-center text-zinc-400 py-10">
                  Loading cards…
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {editingCard && (
        <CardChangeRequestModal
          card={editingCard}
          onClose={() => setEditingCard(null)}
        />
      )}
    </>
  );
}
